var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 16.5V4.83333C6.66663 4.05836 6.66663 3.67087 6.75181 3.35295C6.98298 2.49022 7.65685 1.81635 8.51958 1.58519C8.8375 1.5 9.22498 1.5 9.99996 1.5C10.7749 1.5 11.1624 1.5 11.4803 1.58519C12.3431 1.81635 13.0169 2.49022 13.2481 3.35295C13.3333 3.67087 13.3333 4.05836 13.3333 4.83333V16.5M4.33329 16.5H15.6666C16.6 16.5 17.0668 16.5 17.4233 16.3183C17.7369 16.1586 17.9918 15.9036 18.1516 15.59C18.3333 15.2335 18.3333 14.7668 18.3333 13.8333V7.5C18.3333 6.56658 18.3333 6.09987 18.1516 5.74335C17.9918 5.42975 17.7369 5.17478 17.4233 5.01499C17.0668 4.83333 16.6 4.83333 15.6666 4.83333H4.33329C3.39987 4.83333 2.93316 4.83333 2.57664 5.01499C2.26304 5.17478 2.00807 5.42975 1.84828 5.74335C1.66663 6.09987 1.66663 6.56658 1.66663 7.5V13.8333C1.66663 14.7668 1.66663 15.2335 1.84828 15.59C2.00807 15.9036 2.26304 16.1586 2.57664 16.3183C2.93316 16.5 3.39987 16.5 4.33329 16.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.388435bc853cfe7adfd6f3f724da2010.svg";
export { ForwardRef as ReactComponent };